// Constants
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
var NO_VISIBLE_ACTION_COUNT = 0;
var VISIBLE_ACTION_COUNT = 1;
export var getVisibleActionCount = function getVisibleActionCount() {
  var actions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ARRAY;
  var actionsLength = actions.length;
  if (actionsLength > 1) {
    return NO_VISIBLE_ACTION_COUNT;
  }
  if (actionsLength === 1) {
    return NO_VISIBLE_ACTION_COUNT;
  }
  return undefined;
};
export var getActionsForRow = function getActionsForRow(original, getRowActions) {
  return getRowActions(original);
};